import React, { useState } from 'react';
import { X, Calendar, Clock } from 'lucide-react';

const ScheduleModal = ({ isOpen, onClose, onSchedule }) => {
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');

    if (!isOpen) return null;

    const handleSchedule = () => {
        if (!date || !time) {
            alert("Please select both date and time.");
            return;
        }
        const scheduledDate = new Date(`${date}T${time}`);
        if (scheduledDate <= new Date()) {
            alert("Please select a future time.");
            return;
        }
        onSchedule(scheduledDate.getTime());
        onClose();
    };

    const setQuickTime = (type) => {
        const now = new Date();
        let target = new Date();

        if (type === 'tonight') {
            target.setHours(20, 0, 0, 0);
            if (target <= now) target.setDate(target.getDate() + 1);
        } else if (type === 'tomorrow_morning') {
            target.setDate(target.getDate() + 1);
            target.setHours(9, 0, 0, 0);
        }

        setDate(target.toISOString().split('T')[0]);
        setTime(target.toTimeString().slice(0, 5));
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-80 shadow-xl">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="font-bold text-lg">Schedule Message</h3>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600"><X size={20} /></button>
                </div>

                <div className="space-y-4">
                    <div>
                        <label className="block text-xs font-medium text-slate-500 mb-1">Date</label>
                        <div className="relative">
                            <Calendar className="absolute left-3 top-2.5 text-slate-400" size={16} />
                            <input
                                type="date"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                className="w-full pl-10 pr-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-purple-500"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-medium text-slate-500 mb-1">Time</label>
                        <div className="relative">
                            <Clock className="absolute left-3 top-2.5 text-slate-400" size={16} />
                            <input
                                type="time"
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                                className="w-full pl-10 pr-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-purple-500"
                            />
                        </div>
                    </div>

                    <div className="flex gap-2">
                        <button onClick={() => setQuickTime('tonight')} className="flex-1 py-1 px-2 bg-purple-50 text-purple-600 text-xs rounded hover:bg-purple-100">Tonight (8 PM)</button>
                        <button onClick={() => setQuickTime('tomorrow_morning')} className="flex-1 py-1 px-2 bg-purple-50 text-purple-600 text-xs rounded hover:bg-purple-100">Tomorrow (9 AM)</button>
                    </div>

                    <button
                        onClick={handleSchedule}
                        className="w-full py-2 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 transition-colors"
                    >
                        Schedule Send
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ScheduleModal;
